import apiClient from '../config/axios';
import {getUser, getUserHeader} from "./UserService";

export async function getAllOrders() {
	const response = await apiClient.get("/api/orders", getUserHeader());
	// console.table(response.data);
	return response.data;
}

export async function getLeaderboard() {
	const response = await apiClient.get("/api/leaderboard", getUserHeader());
	return response.data;
}

export async function getSpeltakList() {
	const response = await apiClient.get("/api/speltak", getUserHeader());
	return response.data;
}

export async function createOrder(data) {
	let user = await getUser();
	if (!user.row) {
		return;
	}
	data.meta_data = [
		{
			key: "salesPerson",
			value: user.user
		}
	];
	let response = await apiClient.post("/api/orders", {order: data}, getUserHeader());
	// console.log("order created", response);
	return response.data;
}

export async function getZones() {
	const response = await apiClient.get("/api/zones");
	console.log("get zones response", response);
	return response.data;
}
// Cache key and expiration time (5 minutes)
const PRODUCTS_CACHE_KEY = 'oliebol_products_cache';
const PRODUCTS_CACHE_EXPIRY = 5 * 60 * 1000; // 5 minutes in milliseconds

/**
 * Get cached products if available and not expired
 */
export function getCachedProducts() {
	try {
		const cached = localStorage.getItem(PRODUCTS_CACHE_KEY);
		if (!cached) return null;
		
		const { data, timestamp } = JSON.parse(cached);
		const now = Date.now();
		
		// Check if cache is still valid
		if (now - timestamp < PRODUCTS_CACHE_EXPIRY) {
			return data;
		}
		
		// Cache expired, remove it
		localStorage.removeItem(PRODUCTS_CACHE_KEY);
		return null;
	} catch (error) {
		console.error('Error reading products cache:', error);
		localStorage.removeItem(PRODUCTS_CACHE_KEY);
		return null;
	}
}

/**
 * Save products to cache
 */
function setCachedProducts(products) {
	try {
		const cacheData = {
			data: products,
			timestamp: Date.now()
		};
		localStorage.setItem(PRODUCTS_CACHE_KEY, JSON.stringify(cacheData));
	} catch (error) {
		console.error('Error saving products cache:', error);
	}
}

/**
 * Get products with caching
 * Always fetches fresh data on page load to validate cache
 * Returns cached products immediately if available for instant display
 */
export async function getProducts(useCache = true, forceRefresh = false) {
	// If forcing refresh, skip cache
	if (forceRefresh) {
		return await fetchProducts();
	}
	
	// Return cached products immediately if available
	if (useCache) {
		const cached = getCachedProducts();
		if (cached) {
			// Always validate cache in background on page load
			// This ensures we have fresh data and update if stock status changed
			validateProductsCache().then(freshProducts => {
				// If validation succeeded and stock status changed, trigger update
				if (freshProducts) {
					// Dispatch custom event to notify components of cache update
					window.dispatchEvent(new CustomEvent('productsCacheUpdated', {
						detail: freshProducts
					}));
				}
			}).catch(() => {
				// Validation failed, keep using cached data
			});
			return cached;
		}
	}
	
	// No valid cache, fetch fresh data
	return await fetchProducts();
}

/**
 * Fetch fresh products from API
 */
async function fetchProducts() {
	try {
		const response = await apiClient.get("/api/products");
		const products = response.data;
		
		// Cache the fresh data
		setCachedProducts(products);
		
		return products;
	} catch (error) {
		console.error('Error fetching products:', error);
		throw error;
	}
}

/**
 * Validate cache by fetching fresh data and updating if different
 * Returns fresh products if validation succeeded
 */
async function validateProductsCache() {
	try {
		const freshProducts = await fetchProducts();
		const cached = getCachedProducts();
		
		// Compare stock status - if different, cache was stale
		if (cached && (
			cached.met?.stock_status !== freshProducts.met?.stock_status ||
			cached.zonder?.stock_status !== freshProducts.zonder?.stock_status
		)) {
			// Cache was stale, already updated by fetchProducts
			console.log('Products cache updated - stock status changed');
		}
		
		return freshProducts;
	} catch (error) {
		// If validation fails, keep using cached data
		console.error('Error validating products cache:', error);
		return null;
	}
}
